export default __webpack_public_path__ + "1912b238810497b13dab5bf6bcbb3cd2.svg";